export default {
    getUser: (state) => state.user,
    getToken: (state) => state.token,
    getAuth: (state) => state.authenticated
}